import React from 'react';
import Tabs from '../../../../../components/Tabs/Tabs';
import PreviewProductDetail from '../../PreviewProductDetail';
import Modal from '../../../../../components/Modal';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { getDirectDeliveryTimeAvailable } from '../../../../../lib/utils/productUtils';
import './PreviewProductDetailModal.scss';

const PreviewProductDetailModal = (props) => {
  const {
    isOpen,
    closeModal,
    next,
    prev,
    extraToggle,
    isShowExtra,
    isShowDeliveryInfoLayer,
    imgPage,
    data,
    deliveryInfoLayerToggle,
  } = props;
  const { directDeliveryTimeLimit, disabledActiveValue } = data;

  return (
    <Modal
      title={' '}
      wrapClassName="product-preview-detail-modal-wrapper"
      onClose={() => closeModal()}
      isOpen={isOpen}
      width={375}
      height={685}
      isFooter={false}
      onOk={() => closeModal()}
    >
      <Tabs
        className="preview-product-detail-tab"
        list={[
          {
            title: '앱 노출 화면',
            content: (
              <PreviewProductDetail
                showActualValue={true}
                next={next}
                prev={prev}
                extraToggle={extraToggle}
                isShowExtra={isShowExtra}
                isShowDeliveryInfoLayer={isShowDeliveryInfoLayer}
                imgPage={imgPage}
                data={data}
                deliveryInfoLayerToggle={deliveryInfoLayerToggle}
                directDeliveryTimeAvailable={getDirectDeliveryTimeAvailable(
                  directDeliveryTimeLimit,
                  DATE_FORMAT.YMD_HM_DASH_FORMAT,
                )}
              />
            ),
            disabled: disabledActiveValue,
          },
          {
            title: '일반 화면',
            content: (
              <PreviewProductDetail
                next={next}
                prev={prev}
                extraToggle={extraToggle}
                isShowExtra={isShowExtra}
                isShowDeliveryInfoLayer={isShowDeliveryInfoLayer}
                imgPage={imgPage}
                data={data}
                deliveryInfoLayerToggle={deliveryInfoLayerToggle}
                directDeliveryTimeAvailable={true}
              />
            ),
          },
        ]}
      />
    </Modal>
  );
};

export default PreviewProductDetailModal;
